var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 9.22504C1.25 5.6489 4.05754 2.75 7.52083 2.75C9.27549 2.75 10.8618 3.49412 12 4.69342C13.1382 3.49412 14.7245 2.75 16.4792 2.75C19.9425 2.75 22.75 5.6489 22.75 9.22504C22.75 16.5011 15.4633 19.4 12 21.25C8.53671 19.4 1.25 16.5011 1.25 9.22504Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.c4a4f97f9f49b51aec52103f262e519c.svg";
export { ForwardRef as ReactComponent };